import React, { useState } from 'react';
import { signIn } from '../../lib/helenApi';

const SignIn = ({ onSignedIn }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      onSignedIn(await signIn(username, password));
    } catch (err) {
      setError(err.message);
      setBusy(false);
    }
  };

  return (
    <div className="helen-gate">
      <form className="helen-gate-card" onSubmit={submit}>
        <label className="helen-field" htmlFor="helen-username">
          <span className="helen-visually-hidden">Username</span>
          <input
            id="helen-username"
            name="username"
            placeholder="Username"
            autoComplete="username"
            autoCapitalize="none"
            autoCorrect="off"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </label>

        <label className="helen-field" htmlFor="helen-password">
          <span className="helen-visually-hidden">Password</span>
          <input
            id="helen-password"
            name="password"
            type="password"
            placeholder="Password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>

        {error && (
          <p className="helen-gate-error" role="alert">
            {error}
          </p>
        )}

        <button type="submit" className="helen-button" disabled={busy || !username || !password}>
          {busy ? 'One moment' : 'Come in'}
        </button>
      </form>
    </div>
  );
};

export default SignIn;
